export default "__VITE_ASSET__d925dc0e__"